$ ->
  slider =
    init: ->
      @cacheDom()
      @setActive(0)
      @bindEvent()

    cacheDom: ->
      @$sliderNav = $ '.slider-nav'
      @$sliderItem = $ 'li', @$sliderNav
      @index = 1
      @timer = setInterval (=> @clickNavi()), 7000

    bindEvent: ->
      @$sliderItem.on 'mouseenter', => @stopTimer()
      @$sliderItem.on 'mouseleave', => @startTimer()

    setActive: (i) ->
      $('.js-story_' + i).addClass 'is-current'

    clickNavi: ->
      $('.js-story_' + @index).click()
      if @index == 2
        @index = 0
      else
        @index++

    stopTimer: ->
      if @timer > 0
        clearInterval @timer
        @timer = 0

    startTimer: ->
      @timer = setInterval (=> @clickNavi()), 7000

  slider.init() if $('body').hasClass('about-usecase-page')
